import type { ArdoqId } from '@ardoq/api-types';
import {
  compareComponents,
  SortAttribute,
  type ContextSort,
} from '@ardoq/common-helpers';
import type { Locale } from '@ardoq/locale';
import type { EnhancedScopeData } from '@ardoq/data-model';
import { enhancedScopeDataOperations } from '@ardoq/scope-data';

const compareComponentIds = (
  componentIdA: ArdoqId,
  componentIdB: ArdoqId,
  sort: ContextSort,
  locale: Locale,
  scopeData: EnhancedScopeData,
  workspaceIds: ArdoqId[]
) => {
  const componentA = enhancedScopeDataOperations.getComponent(
    scopeData,
    componentIdA
  );
  const componentB = enhancedScopeDataOperations.getComponent(
    scopeData,
    componentIdB
  );

  if (!componentA || !componentB) {
    return 0;
  }

  if (sort.attr === SortAttribute.ORDER) {
    const workspaceAIndex = workspaceIds.indexOf(componentA.rootWorkspace);
    const workspaceBIndex = workspaceIds.indexOf(componentB.rootWorkspace);
    if (workspaceAIndex !== workspaceBIndex) {
      return workspaceAIndex - workspaceBIndex;
    }
  }
  return compareComponents(componentA, componentB, sort, locale);
};

export { compareComponentIds };
